module.exports = __webpack_public_path__ + "img/finanziario_idle.3da278fa.png";